import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  BackendUpdateResponse,
  DatastoreCollection,
  ProjectCollaborationAction,
  ProjectCollaborationsCollection,
} from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { ButtonColor } from '@freelancer/ui/button';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { TextSize } from '@freelancer/ui/text';

@Component({
  template: `
    <fl-bit class="RevokeModal">
      <fl-heading
        i18n="Revoke modal heading"
        [headingType]="HeadingType.H3"
        [size]="TextSize.MID"
      >
        Remove collaborator access
      </fl-heading>

      <fl-text
        i18n="Revoke modal notification text"
        [flMarginBottom]="Margin.LARGE"
      >
        You can't undo this action.
      </fl-text>

      <fl-bit class="ButtonGroup">
        <fl-button
          i18n="Cancel button"
          flTrackingLabel="CloseRevokeCollaborationModalButton"
          [color]="ButtonColor.DEFAULT"
          [flMarginRight]="Margin.XSMALL"
          (click)="cancel()"
        >
          Cancel
        </fl-button>

        <fl-button
          i18n="Remove button"
          flTrackingLabel="SaveRevokeCollaborationModalButton"
          [color]="ButtonColor.SECONDARY"
          [busy]="revokePromise && (revokePromise | async) === null"
          (click)="remove()"
        >
          Remove
        </fl-button>
      </fl-bit>
    </fl-bit>
  `,
  styleUrls: ['./project-collaboration-revoke-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectCollaborationRevokeModalComponent {
  ButtonColor = ButtonColor;
  Margin = Margin;
  TextSize = TextSize;
  HeadingType = HeadingType;

  revokePromise: Promise<
    BackendUpdateResponse<ProjectCollaborationsCollection>
  >;

  @Input() projectCollaborationCollection: DatastoreCollection<
    ProjectCollaborationsCollection
  >;
  @Input() collaborationId: number;

  constructor(
    private modalRef: ModalRef<ProjectCollaborationRevokeModalComponent>,
  ) {}

  cancel() {
    this.modalRef.close(false);
  }

  remove() {
    this.revokePromise = this.projectCollaborationCollection
      .update(this.collaborationId, {
        action: ProjectCollaborationAction.REVOKE,
      })
      .then(response => {
        if (response.status === 'success') {
          this.cancel();
        } else {
          this.modalRef.close(true);
        }
        return response;
      });
  }
}
